<template>
  <div class="language_switcher d-flex align-items-center">
    <div class="custom-select-display" @click="toggleDropdown">
      {{ selectedLanguage.name }}
      <span class="px-1">|</span>
      <img src="@/assets/images/world.svg" alt="languages" class="mr-2" width="20" height="20" />
    </div>

    <div class="custom-options" v-if="isDropdownOpen" @click.stop>
      <div
        v-for="(language, index) in languages"
        :key="index"
        class="custom-option"
        @click="selectLanguage(language)"
      >
        {{ language.name }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import handleError from "../../helper/handleError";
import { useLanguageStore } from "../../store/languageStore";

export default defineComponent({
  name: "LanguageSwitcher",
  setup() {
    const languageStore = useLanguageStore();
    const { locale } = useI18n();

    const languages = ref([
      { name: "EN", value: "en" },
      { name: "AR", value: "ar" },
    ]);

    const selectedLanguage = ref(
      languages.value.find(
        (lang) =>
          lang.value ===
          (JSON.parse(localStorage.getItem("selectedLanguage") || '{"value": "ar"}').value)
      ) || languages.value[1] // Default to Arabic if not found
    );

    const isDropdownOpen = ref(false);

    const toggleDropdown = () => {
      isDropdownOpen.value = !isDropdownOpen.value;
    };

    const selectLanguage = (language: { name: string; value: string }) => {
      changeLanguage(language);
      isDropdownOpen.value = false;
    };

    const changeLanguage = (language: { name: string; value: string }) => {
      try {
        languageStore.setLanguage(language); // Update the language in the store
        selectedLanguage.value = language;
        locale.value = language.value; // Update the i18n locale here
      } catch (error) {
        handleError(error);
      }
    };

    onMounted(() => {
      locale.value = selectedLanguage.value.value; // Set the initial locale on component mount
    });

    return {
      languages,
      selectedLanguage,
      isDropdownOpen,
      toggleDropdown,
      selectLanguage,
    };
  },
});
</script>

<style lang="scss">
.language_switcher {
  position: relative;

  .custom-select-display {
    display: flex;
    align-items: center;
    padding: 5px 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    background-color: #fff;
    cursor: pointer;
    font-size: 14px;

    span {
      margin: 0 5px;
    }

    img {
      width: 15px;
      height: 15px;
    }
  }

  .custom-options {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    max-height: 200px;
    overflow-y: auto;

    .custom-option {
      padding: 6px;
      cursor: pointer;
      transition: background-color 0.2s ease;

      &:hover {
        background-color: var(--primary-color);
        color: #fff;
      }
    }
  }
}
</style>
